import { render, staticRenderFns } from "./RegisterTeacherSchedule.vue?vue&type=template&id=36ac1eca&scoped=true&"
import script from "./RegisterTeacherSchedule.vue?vue&type=script&lang=js&"
export * from "./RegisterTeacherSchedule.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTeacherSchedule.vue?vue&type=style&index=0&id=36ac1eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac1eca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
